"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DistributionServiceLive = void 0;
const HttpProvider_1 = require("../utils/HttpProvider");
class DistributionServiceLive {
    async getDistributions(companyId, query = {}) {
        // HttpProvider.get sends its second argument as the request body, which axios omits for GET, so
        // query params must be encoded into the URL — passing `{ params }` silently drops the filter.
        const search = new URLSearchParams();
        if (query.status) {
            search.set("status", query.status);
        }
        if (query.page !== undefined) {
            search.set("page", String(query.page));
        }
        if (query.pageSize !== undefined) {
            search.set("pageSize", String(query.pageSize));
        }
        const queryString = search.toString();
        const url = `/company/${companyId}/distributions${queryString ? `?${queryString}` : ""}`;
        const response = await HttpProvider_1.httpProvider.get(url);
        return response.data;
    }
    async getDistributionStatement(companyId, distributionId, shareholderId, timestamp) {
        const queryString = timestamp !== undefined ? `?timestamp=${timestamp}` : "";
        const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/distributions/${distributionId}/shareholders/${shareholderId}/statement${queryString}`);
        return response.data;
    }
    async getShareholderDistributions(companyId, shareholderId) {
        const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/shareholders/${shareholderId}/distributions`);
        return response.data;
    }
    async getDistribution(companyId, distributionId, options = {}) {
        const url = `/company/${companyId}/distributions/${distributionId}${options.includeAllocations ? "?include=allocations" : ""}`;
        const response = await HttpProvider_1.httpProvider.get(url);
        return response.data;
    }
    async createDistribution(companyId, body) {
        const response = await HttpProvider_1.httpProvider.post(`/company/${companyId}/distributions`, body);
        return response.data;
    }
    async updateDistribution(companyId, distributionId, body) {
        const response = await HttpProvider_1.httpProvider.patch(`/company/${companyId}/distributions/${distributionId}`, body);
        return response.data;
    }
    async deleteDistribution(companyId, distributionId) {
        const response = await HttpProvider_1.httpProvider.delete(`/company/${companyId}/distributions/${distributionId}`);
        return response.data;
    }
    async getDistributionPreview(companyId, distributionId) {
        const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/distributions/${distributionId}/preview`);
        return response.data;
    }
    async getDistributionCsvData(companyId, distributionId) {
        const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/distributions/${distributionId}/csv`);
        return response.data;
    }
    async confirmDistribution(companyId, distributionId, body) {
        const response = await HttpProvider_1.httpProvider.post(`/company/${companyId}/distributions/${distributionId}/confirm`, body);
        return response.data;
    }
    async setDistributionAdminBlock(companyId, distributionId, params) {
        const { shareholderId, blocked } = params;
        const response = await HttpProvider_1.httpProvider.patch(`/company/${companyId}/distributions/${distributionId}/shareholders/${shareholderId}/admin-block`, { blocked });
        return response.data;
    }
    async getDistributionAbaFile(companyId, distributionId) {
        const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/distributions/${distributionId}/aba`);
        return response.data;
    }
    async getDistributionManualPayments(companyId, distributionId) {
        const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/distributions/${distributionId}/manual-payments`);
        return response.data;
    }
    async completeDistribution(companyId, distributionId, publishDate) {
        const response = await HttpProvider_1.httpProvider.post(`/company/${companyId}/distributions/${distributionId}/execute`, {
            ...(publishDate ? { publishDate } : {}),
        });
        return response.data;
    }
    async getDistributionTransactions(companyId, distributionId) {
        const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/distributions/${distributionId}/transactions`);
        return response.data;
    }
}
exports.DistributionServiceLive = DistributionServiceLive;
//# sourceMappingURL=DistributionServiceLive.js.map